export const VirtualizedHierarchicalListName = 'virtualizedHierarchicalListComponent';
